'use client';


import { motion, useInView } from 'framer-motion';
import { getCdnUrl } from '@/utils/cdn';
import { useRef } from 'react';

export default function CardsSection() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, margin: '-100px' });

	const imageVariants = {
		hidden: { clipPath: 'circle(0% at 50% 50%)', opacity: 0 },
		visible: { clipPath: 'circle(150% at 50% 50%)', opacity: 1 },
	};

	return (
		<section ref={ref} className="pt-0 md:pt-8 h-full bg-gray-50 relative 2xl:px-14 w-full flex items-center">
			<div className="w-full 2xl:max-w-[90%] mx-auto">
				{/* Container dos cards flutuantes (desktop/tablet) */}
				<div className="relative min-h-[550px] lg:min-h-[720px] hidden md:block md:scale-[0.5] lg:scale-[0.65] xl:scale-[0.75] 2xl:scale-85 mx-[5%]">
					{/* Card 1 - Esquerda */}
					<div className="absolute top-32 left-4 sm:-left-[5%] w-76 lg:w-96 -rotate-2 z-10 will-change-transform float-y-infinite anim-delay-0">
						<div className="p-10 text-white bg-center bg-no-repeat h-80 md:h-80 lg:h-96 flex flex-col justify-center" style={{ backgroundImage: `url('${getCdnUrl("/images/common/card-bg.webp")}')`, backgroundSize: '100% 100%' }}>
							<h3 className="text-2xl font-bold mb-3">Facilidades de financiamento</h3>
							<p className="text-2xl">Subsídios para renda de até R$4.500,00</p>
							
							{/* Rodinha animada na ponta esquerda do card */}
							<div className="absolute -top-12 -left-16 z-30">
								<img src={getCdnUrl("/images/common/cta-register.webp")} alt="Selo cadastro" width={168} height={168} className="animate-spin-slow" />
							</div>
						</div>
					</div>

					{/* Card 2 - Centro */}
					<div className="absolute top-36 left-[32%]  2xl:left-[33%] transform -translate-x-1/2 w-96 lg:w-[28rem] rotate-1 z-[12] will-change-transform float-y-infinite anim-delay-200">
						<div className="p-10 lg:p-12 text-white bg-center bg-no-repeat h-80 md:h-72 lg:h-[420px] flex flex-col justify-center" style={{ backgroundImage: `url('${getCdnUrl("/images/common/card-bg.webp")}')`, backgroundSize: '100% 100%' }}>
							<h3 className="text-4xl  leading-snug">Menores taxas de juros do mercado</h3>
						</div>
					</div>

					{/* Card 3 - Direita */}
					<div className="absolute top-60 right-4 sm:-right-[8%] 2xl:-right-[10%] w-76 lg:w-96 rotate-2 z-[20] will-change-transform float-y-infinite anim-delay-400">
						<div className="p-10 text-white bg-center bg-no-repeat h-80 md:h-72 lg:h-[350px] flex flex-col justify-center" style={{ backgroundImage: `url('${getCdnUrl("/images/common/card-bg.webp")}')`, backgroundSize: '100% 100%' }}>
							<h3 className="text-2xl  mb-3">Facilidades de financiamento</h3>
							<p className="text-2xl">Subsídios para renda de até R$4.500,00</p>
						</div>
					</div>

					{/* Imagem decorativa abaixo do terceiro card, sobreposta pelo card */}
					<img src={getCdnUrl("/images/common/decor-ativo-3.webp")} alt="Decorativo" className="absolute -bottom-0 -right-80 w-[32rem] lg:w-[60rem] z-[5] opacity-40 h-full" />
				</div>

				{/* Versão mobile: cards empilhados */}
				<div className="md:hidden space-y-4 sm:space-y-8 sm:pb-0 sm:scale-65">
					<div className="transform rotate-2 ml-8 mr-32 relative">
						<div className="will-change-transform float-y-infinite anim-delay-200">
							<div className="p-6 rounded-3xl text-white bg-center bg-no-repeat h-56 flex flex-col justify-center" style={{ backgroundImage: `url('${getCdnUrl("/images/common/card-bg.webp")}')`, backgroundSize: '100% 100%' }}>
								<h3 className="text-lg font-bold">Menores taxas de juros do mercado</h3>
							</div>
						</div>
						{/* Rodinha animada na ponta direita do card mobile */}
						<div className="absolute -bottom-4 -right-10 z-30">
							<img src={getCdnUrl("/images/common/cta-register.webp")} alt="Selo cadastro" width={112} height={112} className="animate-spin-slow" />
						</div>
					</div>
					<div className="transform -rotate-2 ml-24 mr-6 relative will-change-transform float-y-infinite anim-delay-0">
						<div className="p-6 rounded-3xl text-white bg-center bg-no-repeat h-56 flex flex-col justify-center mx-4" style={{ backgroundImage: `url('${getCdnUrl("/images/common/card-bg.webp")}')`, backgroundSize: '100% 100%' }}>
							<h3 className="text-lg  mb-2">Facilidades de financiamento</h3>
							<p className="text-sm">Subsídios para renda de até R$4.500,00</p>
						</div>
					</div>
						<div className="transform rotate-2 ml-8 mr-32 will-change-transform float-y-infinite anim-delay-400">
						<div className="p-6 rounded-3xl  text-white bg-center bg-no-repeat h-56 flex flex-col justify-center " style={{ backgroundImage: `url('${getCdnUrl("/images/common/card-bg.webp")}')`, backgroundSize: '100% 100%' }}>
							<h3 className="text-lg font-bold mb-2">Facilidades de financiamento</h3>
							<p className="text-sm">Subsídios para renda de até R$4.500,00</p>
						</div>
					</div>
				</div>
			</div>

			{/* Imagem decorativa posicionada à esquerda, um pouco para dentro antes do primeiro card */}
			<motion.div
				variants={imageVariants}
				initial="hidden"
				animate={isInView ? 'visible' : 'hidden'}
				transition={{ duration: 1.5, ease: 'easeOut', delay: 0.3 }}
				className="absolute bottom-6 left-24 md:left-0 2xl:left-28 hidden md:block  "
			>
				<img src={getCdnUrl("/images/common/decor-ativo-1.webp")} alt="Decoração" className="w-56 md:w-72 h-auto" />
			</motion.div>

			{/* Elementos de fundo sutis */}
			<div className="absolute top-1/4 right-1/4 w-32 h-32 bg-forbli-green/10 rounded-full opacity-30 blur-xl" />
			<div className="absolute bottom-1/4 left-1/3 w-24 h-24 bg-forbli-lime/10 rounded-full opacity-40 blur-lg" />
		</section>
	);
}
